import navigation from './navigation';
import starbucks from './starbucks';

const combinedTranslations = {
  ...navigation,
  ...starbucks,
};

export default combinedTranslations;
